import { render, staticRenderFns } from "./Grower.vue?vue&type=template&id=4fd2eb4c&scoped=true&"
import script from "./Grower.vue?vue&type=script&lang=js&"
export * from "./Grower.vue?vue&type=script&lang=js&"
import style0 from "./Grower.vue?vue&type=style&index=0&id=4fd2eb4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd2eb4c",
  null
  
)

export default component.exports